import React from "react";
import I18n from "../../../i18n/";
import { CounselingGeneric } from "./index";
import ReportAction from "../../../actions/ReportAction";
import { CounselingSupportGraph } from "../../../constants/supportGraph";
import { TargetValueType } from "../CompareValuePanel";
import { OrgUtil } from "../../../util";

export default (props)=>(
	<CounselingGeneric 
		typeKey={CounselingSupportGraph.AgeRange}
		subHeader={I18n.t("age_range")}
		fetchMain={ReportAction.fetchCounAge}
	/>
);


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Counseling/CounselingAgeRange.js